import React, { useEffect, useRef } from 'react';
import { observer, useLocalStore } from 'mobx-react';
import styles from './index.module.scss';
import { ReactComponent as Vector } from '@/assets/vector.svg';
import { Right } from '@icon-park/react';
import i18next from 'i18next';

// 哪些路径隐藏 入口
const hideEntry = ['/gateway/docs/index', '/gateway/docs/index/'];

function Entry() {
  const ref = useRef<HTMLDivElement>(null);
  const state = useLocalStore(() => ({
    isRender: false,
    isDrag: false,
  }));

  useEffect(() => {
    if (ref.current) {
      setTimeout(() => {
        state.isRender = true;
        const { width } = (ref.current as HTMLDivElement).getBoundingClientRect();
        (ref.current as any).style.left = `${window.innerWidth - width}px`;
        (ref.current as any).style.top = `${window.innerHeight - 200}px`;
      }, 4000);

      (ref.current as HTMLDivElement).addEventListener('mousedown', (ee) => {
        const startX = ee.pageX;
        const startY = ee.pageY;
        const {
          x, y, width, height,
        } = (ref.current as HTMLDivElement).getBoundingClientRect();
        document.onmousemove = (e) => {
          let stepX = e.pageX - startX + x;
          let stepY = e.pageY - startY + y;
          // 边界条件
          stepX = stepX < 0 ? 0 : stepX;
          stepX = stepX > window.innerWidth - width ? window.innerWidth - width : stepX;
          stepY = stepY < 0 ? 0 : stepY;
          stepY = stepY > window.innerHeight - height ? window.innerHeight - height : stepY;
          (ref.current as any).style.left = `${stepX}px`;
          (ref.current as any).style.top = `${stepY}px`;
        };
      });
      document.addEventListener('mouseup', () => {
        document.onmousemove = null;
      });
    }
  }, []);

  if (hideEntry.includes(window.location.pathname)) {
    return <div />;
  }

  return (
    <div
      className={styles.entry}
      style={{
        visibility: state.isRender ? 'visible' : 'hidden',
      }}
      ref={ref}
    >
      <div className={styles.context}>
        <div className={styles.item}>
          <a href="lark://client/chat/6956489210853343233" rel="nofollow">{i18next.t('feedback_entry')}</a>
          <Right />
        </div>
      </div>
      <div className={styles.container}>
        <Vector />
      </div>
    </div>
  );
}

export default React.memo(observer(Entry));
